import { render, staticRenderFns } from "./ProfileIdentVolunteerForm.vue?vue&type=template&id=afb0ac06"
import script from "./ProfileIdentVolunteerForm.vue?vue&type=script&lang=ts"
export * from "./ProfileIdentVolunteerForm.vue?vue&type=script&lang=ts"
import style0 from "./ProfileIdentVolunteerForm.vue?vue&type=style&index=0&id=afb0ac06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports